module.exports = __webpack_public_path__ + "app-static/img/p_06.9cee38f3.jpg";